import { render, staticRenderFns } from "./LandingBackgroundImage.vue?vue&type=template&id=4c7fbf74&scoped=true"
import script from "./LandingBackgroundImage.vue?vue&type=script&lang=js"
export * from "./LandingBackgroundImage.vue?vue&type=script&lang=js"
import style0 from "./LandingBackgroundImage.vue?vue&type=style&index=0&id=4c7fbf74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7fbf74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7fbf74')) {
      api.createRecord('4c7fbf74', component.options)
    } else {
      api.reload('4c7fbf74', component.options)
    }
    module.hot.accept("./LandingBackgroundImage.vue?vue&type=template&id=4c7fbf74&scoped=true", function () {
      api.rerender('4c7fbf74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Landing/components/LandingBackgroundImage.vue"
export default component.exports